import { JetView } from 'webix-jet'; // Importing JetView class from webix-jet for creating views
import { allpayments } from 'models/allpayments'; // Importing allpayments model for data handling
import { devConfig } from 'config/config'; // Importing development configuration settings

/**
 * Class representing a view for withdrawal requests table.
 * @extends JetView
 */
export default class tableWithdrawalRequestView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        // Retrieve the localization service and its translation function
        const _ = this.app.getService('locale')._;
        // Format the date according to the application's date format configuration
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat);
        // Get the current user parameter from the request
        const cur_user = this.getParam('user', true);
        // Define the form for unlocking a user by password
        const desbloquear_usuario_clave = {
            view: 'form', // Specify the view type as a form
            margin: 10, // Set margin around the form
            // Determine visibility based on permission configuration
            hidden: !devConfig.getPermAction(
                'AgentSecurityChangesUserClaveSwitch', // Permission key
                'Switch', // Action type
            ),
            css: 'secutity prm-AgentSecurityChangesUserClaveSwitch', // CSS classes for styling
            id: 'desbloquearclaveestadoUsuario', // Unique identifier for the form
            rows: [
                // Define the rows within the form
                { view: 'label', label: _('Desbloquear Usuario por Clave') }, // Label for the form
                {
                    css: 'centrar', // CSS class for centering the button
                    id: 'UnlockUserByPassword', // Unique identifier for the button
                    view: 'button', // Specify the view type as a button
                    labelWidth: 55, // Set the width of the label
                    value: _('Desbloquear'), // Button label
                    click: () => {
                        // Click event handler for the button
                        webix
                            .ajax() // Initiate an AJAX request
                            .headers({
                                'Content-type': 'application/json', // Set content type to JSON
                            })
                            .post(
                                devConfig.geturlApi() + // API URL for the request
                                'Client/UpdateUserSecurity',
                                '{"Action":"UnlockUserByPassword","Id":' + // Request payload
                                cur_user +
                                ',"IsActivate":"A"}',
                                {
                                    error: function(text, data, XmlHttpRequest) {
                                        // Handle error response
                                        webix.message({
                                            title: _('¡Error!'), // Error title
                                            type: 'alert-error', // Error message type
                                            text: _('Ocurrio un error.'), // Error message text
                                        });
                                    },
                                    success: function(text, data, XmlHttpRequest) {
                                        // Handle successful response
                                        text = JSON.parse(text); // Parse the response text
                                        if (text.HasError) {
                                            // Check for errors in the response
                                            webix.message({
                                                title: _('¡Error!'), // Error title
                                                type: 'alert-error', // Error message type
                                                text: _('Ocurrio un error.'), // Error message text
                                            });
                                        } else {
                                            // Notify user of successful changes
                                            webix.message(_('Cambios Realizados'));
                                        }
                                    },
                                },
                            );
                    },
                },
            ],
        };

        const left = {
            margin: 0, // Margin for the left container
            id: 'a1', // Unique identifier for the left container
            autoheight: true, // Automatically adjust height based on content
            rows: [
                {
                    margin: 0, // Margin for the first row
                    css: 'on-row', // CSS class for styling
                    cols: [
                        desbloquear_usuario_clave, // Reference to another component or variable
                        {
                            view: 'form', // Form view for generating password
                            margin: 10, // Margin for the form
                            css: 'secutity prm-AgentSecurityGeneratePasswordSwitch', // CSS classes for styling
                            id: 'generatePassword', // Unique identifier for the form
                            hidden: !devConfig.getPermAction('AgentSecurityGeneratePasswordSwitch', 'Switch'), // Conditional visibility based on permissions
                            rows: [
                                {
                                    view: 'label', // Label for the form
                                    label: _('Generar contraseña'), // Label text for generating password
                                },
                                {
                                    css: 'centrar', // CSS class for centering
                                    id: 'GeneratePassword', // Unique identifier for the button
                                    view: 'button', // Button view
                                    labelWidth: 55, // Width of the label next to the button
                                    value: _('Generar'), // Button text for generating
                                    click: () => { // Click event handler for the button
                                        webix
                                            .ajax() // Initiating an AJAX request
                                            .headers({
                                                'Content-type': 'application/json', // Setting content type for the request
                                            })
                                            .post(
                                                devConfig.geturlApi() + 'Client/UpdateUserSecurity', // API endpoint for updating user security
                                                '{"Action":"GeneratePassword","Id":' + cur_user + ',"IsActivate":"A"}', // Request payload
                                                {
                                                    error: function(text, data, XmlHttpRequest) { // Error callback
                                                        webix.message({
                                                            title: _('¡Error!'), // Error message title
                                                            type: 'alert-error', // Type of alert
                                                            text: _('Ocurrio un error.'), // Error message text
                                                        });
                                                    },
                                                    success: function(text, data, XmlHttpRequest) { // Success callback
                                                        text = JSON.parse(text); // Parsing response text
                                                        if (text.HasError) { // Checking for errors in response
                                                            webix.message({
                                                                title: _('¡Error!'), // Error message title
                                                                type: 'alert-error', // Type of alert
                                                                text: _('Ocurrio un error.'), // Error message text
                                                            });
                                                        } else {
                                                            webix.message(_('Cambios Realizados')); // Success message
                                                        }
                                                    },
                                                },
                                            );
                                    },
                                },
                            ],
                        },
                        {
                            view: 'form', // Another form view for generating a second password
                            margin: 10, // Margin for the form
                            css: 'secutity prm-AgentSecurityGeneratePassword2Switch', // CSS classes for styling
                            id: 'generatePassword', // Unique identifier for the form
                            hidden: !devConfig.getPermAction('AgentSecurityGeneratePassword2Switch', 'Switch'), // Conditional visibility based on permissions
                            rows: [
                                {
                                    view: 'label', // Label for the form
                                    label: _('Generar contraseña'), // Label text for generating password
                                },
                                {
                                    css: 'centrar', // CSS class for centering
                                    id: 'GeneratePassword2', // Unique identifier for the button
                                    view: 'button', // Button view
                                    labelWidth: 55, // Width of the label next to the button
                                    value: _('Generar'), // Button text for generating
                                    click: () => { // Click event handler for the button
                                        webix
                                            .ajax() // Initiating an AJAX request
                                            .headers({
                                                'Content-type': 'application/json', // Setting content type for the request
                                            })
                                            .post(
                                                devConfig.geturlApi() + 'Client/UpdateUserSecurity', // API endpoint for updating user security
                                                '{"Action":"GeneratePassword2","Id":' + cur_user + ',"IsActivate":"A"}', // Request payload
                                                {
                                                    error: function(text, data, XmlHttpRequest) { // Error callback
                                                        webix.message({
                                                            title: _('¡Error!'), // Error message title
                                                            type: 'alert-error', // Type of alert
                                                            text: _('Ocurrio un error.'), // Error message text
                                                        });
                                                    },
                                                    success: function(text, data, XmlHttpRequest) { // Success callback
                                                        text = JSON.parse(text); // Parsing response text
                                                        if (text.HasError) { // Checking for errors in response
                                                            webix.message({
                                                                title: _('¡Error!'), // Error message title
                                                                type: 'alert-error', // Type of alert
                                                                text: _('Ocurrio un error.'), // Error message text
                                                            });
                                                        } else {
                                                            webix.message({
                                                                title: _('Contraseña cambiada'), // Success message title
                                                                type: 'alert-warning', // Type of alert
                                                                text: text.Data, // Success message text
                                                            });
                                                        }
                                                    },
                                                },
                                            );
                                    },
                                },
                            ],
                        },
                        {
                            view: 'form', // Form view for changing user state
                            css: 'secutity prm-AgentSecurityChangesUserEstadoSwitch', // CSS classes for styling
                            hidden: !devConfig.getPermAction('AgentSecurityChangesUserEstadoSwitch', 'Switch'), // Conditional visibility based on permissions
                            id: 'estadoUsuario', // Unique identifier for the form
                            rows: [
                                {
                                    view: 'label', // Label for the form
                                    label: _('Estado de Usuario'), // Label text for user state
                                },
                                {
                                    css: 'centrar', // CSS class for centering
                                    id: 'StateSwith', // Unique identifier for the switch
                                    view: 'switch', // Switch view for user state
                                    labelWidth: 55, // Width of the label next to the switch
                                    onLabel: _('Activo'), // Label for the 'on' state
                                    offLabel: _('Inactivo'), // Label for the 'off' state
                                    click: () => { // Click event handler for the switch
                                        if ($$('StateSwith').getValue() == 1) { // Checking if switch is on
                                            webix
                                                .ajax() // Initiating an AJAX request
                                                .headers({
                                                    'Content-type': 'application/json', // Setting content type for the request
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'Client/UpdateUserSecurity', // API endpoint for updating user security
                                                    '{"Action":"State","Id":' + cur_user + ',"IsActivate":"A"}', // Request payload
                                                    {
                                                        error: function(text, data, XmlHttpRequest) { // Error callback
                                                            webix.message({
                                                                title: _('¡Error!'), // Error message title
                                                                type: 'alert-error', // Type of alert
                                                                text: _('Ocurrio un error.'), // Error message text
                                                            });
                                                        },
                                                        success: function(text, data, XmlHttpRequest) { // Success callback
                                                            webix.message(_('Cambios Realizados')); // Success message
                                                            $$('StateSwith').setValue(1); // Setting switch value
                                                        },
                                                    },
                                                );
                                        } else {
                                            webix
                                                .ajax() // Initiating an AJAX request
                                                .headers({
                                                    'Content-type': 'application/json', // Setting content type for the request
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'Client/UpdateUserSecurity', // API endpoint for updating user security
                                                    '{"Action":"State","Id":' + cur_user + ',"IsActivate":"I"}', // Request payload
                                                    {
                                                        error: function(text, data, XmlHttpRequest) { // Error callback
                                                            webix.message({
                                                                title: _('¡Error!'), // Error message title
                                                                type: 'alert-error', // Type of alert
                                                                text: _('Ocurrio un error.'), // Error message text
                                                            });
                                                        },
                                                        success: function(text, data, XmlHttpRequest) { // Success callback
                                                            webix.message(_('Cambios Realizados')); // Success message
                                                            $$('StateSwith').setValue(0); // Setting switch value
                                                        },
                                                    },
                                                );
                                        }
                                    },
                                },
                            ],
                        },
                        {
                            view: 'form', // Form view for changing contingency state
                            id: 'Contingency', // Unique identifier for the form
                            hidden: !devConfig.getPermAction('AgentSecurityChangesContingencyEstadoSwitch', 'Switch'), // Conditional visibility based on permissions
                            css: 'secutity prm-AgentSecurityChangesContingencyEstadoSwitch', // CSS classes for styling
                            rows: [
                                {
                                    view: 'label', // Label for the form
                                    label: _('Estado de Contingencia'), // Label text for contingency state
                                },
                                {
                                    id: 'StateContingencySwith', // Unique identifier for the switch
                                    view: 'switch', // Switch view for contingency state
                                    labelWidth: 55, // Width of the label next to the switch
                                    onLabel: _('Activo'), // Label for the 'on' state
                                    offLabel: _('Inactivo'), // Label for the 'off' state
                                    click: () => { // Click event handler for the switch
                                        if ($$('StateContingencySwith').getValue() == 1) { // Checking if switch is on
                                            webix
                                                .ajax() // Initiating an AJAX request
                                                .headers({
                                                    'Content-type': 'application/json', // Setting content type for the request
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'Client/UpdateUserSecurity', // API endpoint for updating user security
                                                    '{"Action":"Contingency","Id":' + cur_user + ',"IsActivate":"A"}', // Request payload
                                                    {
                                                        error: function(text, data, XmlHttpRequest) { // Error callback
                                                            webix.message({
                                                                title: _('¡Error!'), // Error message title
                                                                type: 'alert-error', // Type of alert
                                                                text: _('Ocurrio un error.'), // Error message text
                                                            });
                                                        },
                                                        success: function(text, data, XmlHttpRequest) { // Success callback
                                                            webix.message(_('Cambios Realizados')); // Success message
                                                            $$('StateContingencySwith').setValue(1); // Setting switch value
                                                        },
                                                    },
                                                );
                                        } else {
                                            webix
                                                .ajax() // Initiating an AJAX request
                                                .headers({
                                                    'Content-type': 'application/json', // Setting content type for the request
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'Client/UpdateUserSecurity', // API endpoint for updating user security
                                                    '{"Action":"Contingency","Id":' + cur_user + ',"IsActivate":"I"}', // Request payload
                                                    {
                                                        error: function(text, data, XmlHttpRequest) { // Error callback
                                                            webix.message({
                                                                title: _('¡Error!'), // Error message title
                                                                type: 'alert-error', // Type of alert
                                                                text: _('Ocurrio un error.'), // Error message text
                                                            });
                                                        },
                                                        success: function(text, data, XmlHttpRequest) { // Success callback
                                                            webix.message(_('Cambios Realizados')); // Success message
                                                            $$('StateContingencySwith').setValue(0); // Setting switch value
                                                        },
                                                    },
                                                );
                                        }
                                    },
                                },
                            ],
                        },
                        {
                            view: 'form', // Form view for changing sports contingency state
                            id: 'ContingencyDeportivas', // Unique identifier for the form
                            hidden: !devConfig.getPermAction(
                                'AgentSecurityChangesContingencyDeportivasSwitch',
                                'Switch',
                            ), // Conditional visibility based on permissions
                            css: 'secutity prm-AgentSecurityChangesContingencyDeportivasSwitch', // CSS classes for styling
                            rows: [
                                {
                                    view: 'label', // Label for the form
                                    label: _('Contingencia Deportivas'), // Label text for sports contingency
                                },
                                {
                                    id: 'StateContingencyDeportivasSwith', // Unique identifier for the switch
                                    view: 'switch', // Switch view for sports contingency state
                                    labelWidth: 55, // Width of the label next to the switch
                                    onLabel: _('Activo'), // Label for the 'on' state
                                    offLabel: _('Inactivo'), // Label for the 'off' state
                                    click: () => { // Click event handler for the switch
                                        if ($$('StateContingencyDeportivasSwith').getValue() == 1) { // Checking if switch is on
                                            webix
                                                .ajax() // Initiating an AJAX request
                                                .headers({
                                                    'Content-type': 'application/json', // Setting content type for the request
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'Client/UpdateUserSecurity', // API endpoint for updating user security
                                                    '{"Action":"ContingencySports","Id":' +
                                                    cur_user +
                                                    ',"IsActivate":"A"}', // Request payload
                                                    {
                                                        error: function(text, data, XmlHttpRequest) { // Error callback
                                                            webix.message({
                                                                title: _('¡Error!'), // Error message title
                                                                type: 'alert-error', // Type of alert
                                                                text: _('Ocurrio un error.'), // Error message text
                                                            });
                                                        },
                                                        success: function(text, data, XmlHttpRequest) { // Success callback
                                                            webix.message(_('Cambios Realizados')); // Success message
                                                            $$('StateContingencyDeportivasSwith').setValue(1); // Setting switch value
                                                        },
                                                    },
                                                );
                                        } else {
                                            webix
                                                .ajax() // Initiating an AJAX request
                                                .headers({
                                                    'Content-type': 'application/json', // Setting content type for the request
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'Client/UpdateUserSecurity', // API endpoint for updating user security
                                                    '{"Action":"ContingencySports","Id":' +
                                                    cur_user +
                                                    ',"IsActivate":"I"}', // Request payload
                                                    {
                                                        error: function(text, data, XmlHttpRequest) { // Error callback
                                                            webix.message({
                                                                title: _('¡Error!'), // Error message title
                                                                type: 'alert-error', // Type of alert
                                                                text: _('Ocurrio un error.'), // Error message text
                                                            });
                                                        },
                                                        success: function(text, data, XmlHttpRequest) { // Success callback
                                                            webix.message(_('Cambios Realizados')); // Success message
                                                            $$('StateContingencyDeportivasSwith').setValue(0); // Setting switch value
                                                        },
                                                    },
                                                );
                                        }
                                    },
                                },
                            ],
                        },
                    ],
                },
                {
                    margin: 0, // Margin for the second row
                    css: 'on-row', // CSS class for styling
                    cols: [
                        {
                            view: 'form', // Form view for changing casino contingency state
                            id: 'ContingencyCasino', // Unique identifier for the form
                            hidden: !devConfig.getPermAction('AgentSecurityChangesContingencyCasinoSwitch', 'Switch'), // Conditional visibility based on permissions
                            css: 'secutity prm-AgentSecurityChangesContingencyCasinoSwitch', // CSS classes for styling
                            rows: [
                                {
                                    view: 'label', // Label for the form
                                    label: _('Contingencia Casino'), // Label text for casino contingency
                                },
                                {
                                    id: 'StateContingencyCasinoSwith', // Unique identifier for the switch
                                    view: 'switch', // Switch view for casino contingency state
                                    labelWidth: 55, // Width of the label next to the switch
                                    onLabel: _('Activo'), // Label for the 'on' state
                                    offLabel: _('Inactivo'), // Label for the 'off' state
                                    click: () => { // Click event handler for the switch
                                        if ($$('StateContingencyCasinoSwith').getValue() == 1) { // Checking if switch is on
                                            webix
                                                .ajax() // Initiating an AJAX request
                                                .headers({
                                                    'Content-type': 'application/json', // Setting content type for the request
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'Client/UpdateUserSecurity', // API endpoint for updating user security
                                                    '{"Action":"ContingencyCasino","Id":' +
                                                    cur_user +
                                                    ',"IsActivate":"A"}', // Request payload
                                                    {
                                                        error: function(text, data, XmlHttpRequest) { // Error callback
                                                            webix.message({
                                                                title: _('¡Error!'), // Error message title
                                                                type: 'alert-error', // Type of alert
                                                                text: _('Ocurrio un error.'), // Error message text
                                                            });
                                                        },
                                                        success: function(text, data, XmlHttpRequest) { // Success callback
                                                            webix.message(_('Cambios Realizados')); // Success message
                                                            $$('StateContingencyCasinoSwith').setValue(1); // Setting switch value
                                                        },
                                                    },
                                                );
                                        } else {
                                            webix
                                                .ajax() // Initiating an AJAX request
                                                .headers({
                                                    'Content-type': 'application/json', // Setting content type for the request
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'Client/UpdateUserSecurity', // API endpoint for updating user security
                                                    '{"Action":"ContingencyCasino","Id":' +
                                                    cur_user +
                                                    ',"IsActivate":"I"}', // Request payload
                                                    {
                                                        error: function(text, data, XmlHttpRequest) { // Error callback
                                                            webix.message({
                                                                title: _('¡Error!'), // Error message title
                                                                type: 'alert-error', // Type of alert
                                                                text: _('Ocurrio un error.'), // Error message text
                                                            });
                                                        },
                                                        success: function(text, data, XmlHttpRequest) { // Success callback
                                                            webix.message(_('Cambios Realizados')); // Success message
                                                            $$('StateContingencyCasinoSwith').setValue(0); // Setting switch value
                                                        },
                                                    },
                                                );
                                        }
                                    },
                                },
                            ],
                        },
                        {
                            view: 'form', // Form view for changing live casino contingency state
                            id: 'ContingencyCasinoVivo', // Unique identifier for the form
                            hidden: !devConfig.getPermAction(
                                'AgentSecurityChangesContingencyCasinoVivoSwitch',
                                'Switch',
                            ), // Conditional visibility based on permissions
                            css: 'secutity prm-AgentSecurityChangesContingencyCasinoVivoSwitch', // CSS classes for styling
                            rows: [
                                {
                                    view: 'label', // Label for the form
                                    label: _('Contingencia Casino en Vivo'), // Label text for live casino contingency
                                },
                                {
                                    id: 'StateContingencyCasinoVivoSwith', // Unique identifier for the switch
                                    view: 'switch', // Switch view for live casino contingency state
                                    labelWidth: 55, // Width of the label next to the switch
                                    onLabel: _('Activo'), // Label for the 'on' state
                                    offLabel: _('Inactivo'), // Label for the 'off' state
                                    click: () => { // Click event handler for the switch
                                        if ($$('StateContingencyCasinoVivoSwith').getValue() == 1) { // Checking if switch is on
                                            webix
                                                .ajax() // Initiating an AJAX request
                                                .headers({
                                                    'Content-type': 'application/json', // Setting content type for the request
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'Client/UpdateUserSecurity', // API endpoint for updating user security
                                                    '{"Action":"ContingencyCasinoVivo","Id":' +
                                                    cur_user +
                                                    ',"IsActivate":"A"}', // Request payload
                                                    {
                                                        error: function(text, data, XmlHttpRequest) { // Error callback
                                                            webix.message({
                                                                title: _('¡Error!'), // Error message title
                                                                type: 'alert-error', // Type of alert
                                                                text: _('Ocurrio un error.'), // Error message text
                                                            });
                                                        },
                                                        success: function(text, data, XmlHttpRequest) { // Success callback
                                                            webix.message(_('Cambios Realizados')); // Success message
                                                            $$('StateContingencyCasinoVivoSwith').setValue(1); // Setting switch value
                                                        },
                                                    },
                                                );
                                        } else {
                                            webix
                                                .ajax() // Initiating an AJAX request
                                                .headers({
                                                    'Content-type': 'application/json', // Setting content type for the request
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'Client/UpdateUserSecurity', // API endpoint for updating user security
                                                    '{"Action":"ContingencyCasinoVivo","Id":' +
                                                    cur_user +
                                                    ',"IsActivate":"I"}', // Request payload
                                                    {
                                                        error: function(text, data, XmlHttpRequest) { // Error callback
                                                            webix.message({
                                                                title: _('¡Error!'), // Error message title
                                                                type: 'alert-error', // Type of alert
                                                                text: _('Ocurrio un error.'), // Error message text
                                                            });
                                                        },
                                                        success: function(text, data, XmlHttpRequest) { // Success callback
                                                            webix.message(_('Cambios Realizados')); // Success message
                                                            $$('StateContingencyCasinoVivoSwith').setValue(0); // Setting switch value
                                                        },
                                                    },
                                                );
                                        }
                                    },
                                },
                            ],
                        },
                        {
                            view: 'form', // Form view for changing virtual contingency state
                            id: 'ContingencyVirtuales', // Unique identifier for the form
                            hidden: !devConfig.getPermAction(
                                'AgentSecurityChangesContingencyVirtualesSwitch',
                                'Switch',
                            ), // Conditional visibility based on permissions
                            css: 'secutity prm-AgentSecurityChangesContingencyVirtualesSwitch', // CSS classes for styling
                            rows: [
                                {
                                    view: 'label', // Label for the form
                                    label: _('Estado de Contingencia Virtuales'), // Label text for virtual contingency
                                },
                                {
                                    id: 'StateContingencyVirtualesSwith', // Unique identifier for the switch
                                    view: 'switch', // Switch view for virtual contingency state
                                    labelWidth: 55, // Width of the label next to the switch
                                    onLabel: _('Activo'), // Label for the 'on' state
                                    offLabel: _('Inactivo'), // Label for the 'off' state
                                    click: () => { // Click event handler for the switch
                                        if ($$('StateContingencyVirtualesSwith').getValue() == 1) { // Checking if switch is on
                                            webix
                                                .ajax() // Initiating an AJAX request
                                                .headers({
                                                    'Content-type': 'application/json', // Setting content type for the request
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'Client/UpdateUserSecurity', // API endpoint for updating user security
                                                    '{"Action":"ContingencyVirtuales","Id":' +
                                                    cur_user +
                                                    ',"IsActivate":"A"}', // Request payload
                                                    {
                                                        error: function(text, data, XmlHttpRequest) { // Error callback
                                                            webix.message({
                                                                title: _('¡Error!'), // Error message title
                                                                type: 'alert-error', // Type of alert
                                                                text: _('Ocurrio un error.'), // Error message text
                                                            });
                                                        },
                                                        success: function(text, data, XmlHttpRequest) { // Success callback
                                                            webix.message(_('Cambios Realizados')); // Success message
                                                            $$('StateContingencyVirtualesSwith').setValue(1); // Setting switch value
                                                        },
                                                    },
                                                );
                                        } else {
                                            webix
                                                .ajax() // Initiating an AJAX request
                                                .headers({
                                                    'Content-type': 'application/json', // Setting content type for the request
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'Client/UpdateUserSecurity', // API endpoint for updating user security
                                                    '{"Action":"ContingencyVirtuales","Id":' +
                                                    cur_user +
                                                    ',"IsActivate":"I"}', // Request payload
                                                    {
                                                        error: function(text, data, XmlHttpRequest) { // Error callback
                                                            webix.message({
                                                                title: _('¡Error!'), // Error message title
                                                                type: 'alert-error', // Type of alert
                                                                text: _('Ocurrio un error.'), // Error message text
                                                            });
                                                        },
                                                        success: function(text, data, XmlHttpRequest) { // Success callback
                                                            webix.message(_('Cambios Realizados')); // Success message
                                                            $$('StateContingencyVirtualesSwith').setValue(0); // Setting switch value
                                                        },
                                                    },
                                                );
                                        }
                                    },
                                },
                            ],
                        },
                        {
                            view: 'form', // Form view for changing poker contingency state
                            id: 'ContingencyPoker', // Unique identifier for the form
                            hidden: !devConfig.getPermAction('AgentSecurityChangesContingencyPokerSwitch', 'Switch'), // Conditional visibility based on permissions
                            css: 'secutity prm-AgentSecurityChangesContingencyPokerSwitch', // CSS classes for styling
                            rows: [
                                {
                                    view: 'label', // Label for the form
                                    label: _('Estado de Contingencia Poker'), // Label text for poker contingency
                                },
                                {
                                    id: 'StateContingencyPokerSwith', // Unique identifier for the switch
                                    view: 'switch', // Switch view for poker contingency state
                                    labelWidth: 55, // Width of the label next to the switch
                                    onLabel: _('Activo'), // Label for the 'on' state
                                    offLabel: _('Inactivo'), // Label for the 'off' state
                                    click: () => { // Click event handler for the switch
                                        if ($$('StateContingencyPokerSwith').getValue() == 1) { // Checking if switch is on
                                            webix
                                                .ajax() // Initiating an AJAX request
                                                .headers({
                                                    'Content-type': 'application/json', // Setting content type for the request
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'Client/UpdateUserSecurity', // API endpoint for updating user security
                                                    '{"Action":"ContingencyPoker","Id":' +
                                                    cur_user +
                                                    ',"IsActivate":"A"}', // Request payload
                                                    {
                                                        error: function(text, data, XmlHttpRequest) { // Error callback
                                                            webix.message({
                                                                title: _('¡Error!'), // Error message title
                                                                type: 'alert-error', // Type of alert
                                                                text: _('Ocurrio un error.'), // Error message text
                                                            });
                                                        },
                                                        success: function(text, data, XmlHttpRequest) { // Success callback
                                                            webix.message(_('Cambios Realizados')); // Success message
                                                            $$('StateContingencyPokerSwith').setValue(1); // Setting switch value
                                                        },
                                                    },
                                                );
                                        } else {
                                            webix
                                                .ajax() // Initiating an AJAX request
                                                .headers({
                                                    'Content-type': 'application/json', // Setting content type for the request
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'Client/UpdateUserSecurity', // API endpoint for updating user security
                                                    '{"Action":"ContingencyPoker","Id":' +
                                                    cur_user +
                                                    ',"IsActivate":"I"}', // Request payload
                                                    {
                                                        error: function(text, data, XmlHttpRequest) { // Error callback
                                                            webix.message({
                                                                title: _('¡Error!'), // Error message title
                                                                type: 'alert-error', // Type of alert
                                                                text: _('Ocurrio un error.'), // Error message text
                                                            });
                                                        },
                                                        success: function(text, data, XmlHttpRequest) { // Success callback
                                                            webix.message(_('Cambios Realizados')); // Success message
                                                            $$('StateContingencyPokerSwith').setValue(0); // Setting switch value
                                                        },
                                                    },
                                                );
                                        }
                                    },
                                },
                            ],
                        },
                    ],
                },
                {
                    margin: 0, // Margin for the third row
                    css: 'on-row', // CSS class for styling
                    cols: [
                        {
                            view: 'form', // Form view for changing IP restriction state
                            id: 'ContingencyRestriccionIP', // Unique identifier for the form
                            hidden: !devConfig.getPermAction(
                                'AgentSecurityChangesContingencyRestriccionIPSwitch',
                                'Switch',
                            ), // Conditional visibility based on permissions
                            css: 'secutity prm-AgentSecurityChangesContingencyRestriccionIPSwitch', // CSS classes for styling
                            rows: [
                                { view: 'label', label: _('Restricción IP') }, // Label for the form
                                {
                                    view: 'text', // Text input for IP address
                                    name: 'IP', // Name of the input
                                    id: 'IP', // Unique identifier for the input
                                    label: _('IP'), // Label text for the input
                                    labelPosition: 'top', // Position of the label
                                    placeholder: _('IP'), // Placeholder text for the input
                                },
                                {
                                    id: 'StateContingencyRestriccionIPSwith', // Unique identifier for the switch
                                    view: 'switch', // Switch view for IP restriction state
                                    labelWidth: 55, // Width of the label next to the switch
                                    onLabel: _('Activo'), // Label for the 'on' state
                                    offLabel: _('Inactivo'), // Label for the 'off' state
                                    click: () => { // Click event handler for the switch
                                        if ($$('StateContingencyRestriccionIPSwith').getValue() == 1) { // Checking if switch is on
                                            webix
                                                .ajax() // Initiating an AJAX request
                                                .headers({
                                                    'Content-type': 'application/json', // Setting content type for the request
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'Client/UpdateUserSecurity', // API endpoint for updating user security
                                                    '{"Action":"ContingencyRestriccionIP","Id":' +
                                                    cur_user +
                                                    ',"IsActivate":"A","IP":"' +
                                                    $$('IP').getValue() +
                                                    '"}', // Request payload
                                                    {
                                                        error: function(text, data, XmlHttpRequest) { // Error callback
                                                            webix.message({
                                                                title: _('¡Error!'), // Error message title
                                                                type: 'alert-error', // Type of alert
                                                                text: _('Ocurrio un error.'), // Error message text
                                                            });
                                                        },
                                                        success: function(text, data, XmlHttpRequest) { // Success callback
                                                            webix.message(_('Cambios Realizados')); // Success message
                                                            $$('StateContingencyRestriccionIPSwith').setValue(1); // Setting switch value
                                                        },
                                                    },
                                                );
                                        } else {
                                            webix
                                                .ajax() // Initiating an AJAX request
                                                .headers({
                                                    'Content-type': 'application/json', // Setting content type for the request
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'Client/UpdateUserSecurity', // API endpoint for updating user security
                                                    '{"Action":"ContingencyRestriccionIP","Id":' +
                                                    cur_user +
                                                    ',"IsActivate":"I","IP":"' +
                                                    $$('IP').getValue() +
                                                    '"}', // Request payload
                                                    {
                                                        error: function(text, data, XmlHttpRequest) { // Error callback
                                                            webix.message({
                                                                title: _('¡Error!'), // Error message title
                                                                type: 'alert-error', // Type of alert
                                                                text: _('Ocurrio un error.'), // Error message text
                                                            });
                                                        },
                                                        success: function(text, data, XmlHttpRequest) { // Success callback
                                                            webix.message(_('Cambios Realizados')); // Success message
                                                            $$('StateContingencyRestriccionIPSwith').setValue(0); // Setting switch value
                                                        },
                                                    },
                                                );
                                        }
                                    },
                                },
                            ],
                        },
                        {
                            view: 'form', // Form view for changing Google token state
                            id: 'ContingencyTokenGoogle', // Unique identifier for the form
                            hidden: !devConfig.getPermAction(
                                'AgentSecurityChangesContingencyTokenGoogleSwitch',
                                'Switch',
                            ), // Conditional visibility based on permissions
                            css: 'secutity prm-AgentSecurityChangesContingencyTokenGoogleSwitch', // CSS classes for styling
                            rows: [
                                { view: 'label', label: _('Token Google') }, // Label for the form
                                {
                                    id: 'StateContingencyTokenGoogleSwith', // Unique identifier for the switch
                                    view: 'switch', // Switch view for Google token state
                                    labelWidth: 55, // Width of the label next to the switch
                                    onLabel: _('Activo'), // Label for the 'on' state
                                    offLabel: _('Inactivo'), // Label for the 'off' state
                                    click: () => { // Click event handler for the switch
                                        if ($$('StateContingencyTokenGoogleSwith').getValue() == 1) { // Checking if switch is on
                                            webix
                                                .ajax() // Initiating an AJAX request
                                                .headers({
                                                    'Content-type': 'application/json', // Setting content type for the request
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'Client/UpdateUserSecurity', // API endpoint for updating user security
                                                    '{"Action":"ContingencyTokenGoogle","Id":' +
                                                    cur_user +
                                                    ',"IsActivate":"A"}', // Request payload
                                                    {
                                                        error: function(text, data, XmlHttpRequest) { // Error callback
                                                            webix.message({
                                                                title: _('¡Error!'), // Error message title
                                                                type: 'alert-error', // Type of alert
                                                                text: _('Ocurrio un error.'), // Error message text
                                                            });
                                                        },
                                                        success: function(text, data, XmlHttpRequest) { // Success callback
                                                            webix.message(_('Cambios Realizados')); // Success message
                                                            $$('StateContingencyTokenGoogleSwith').setValue(1); // Setting switch value
                                                        },
                                                    },
                                                );
                                        } else {
                                            webix
                                                .ajax() // Initiating an AJAX request
                                                .headers({
                                                    'Content-type': 'application/json', // Setting content type for the request
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'Client/UpdateUserSecurity', // API endpoint for updating user security
                                                    '{"Action":"ContingencyTokenGoogle","Id":' +
                                                    cur_user +
                                                    ',"IsActivate":"I"}', // Request payload
                                                    {
                                                        error: function(text, data, XmlHttpRequest) { // Error callback
                                                            webix.message({
                                                                title: _('¡Error!'), // Error message title
                                                                type: 'alert-error', // Type of alert
                                                                text: _('Ocurrio un error.'), // Error message text
                                                            });
                                                        },
                                                        success: function(text, data, XmlHttpRequest) { // Success callback
                                                            webix.message(_('Cambios Realizados')); // Success message
                                                            $$('StateContingencyTokenGoogleSwith').setValue(0); // Setting switch value
                                                        },
                                                    },
                                                );
                                        }
                                    },
                                },
                            ],
                        },
                        {
                            view: 'form', // Form view for changing local token state
                            id: 'ContingencyTokenLocal', // Unique identifier for the form
                            hidden: !devConfig.getPermAction(
                                'AgentSecurityChangesContingencyTokenLocalSwitch',
                                'Switch',
                            ), // Conditional visibility based on permissions
                            css: 'secutity prm-AgentSecurityChangesContingencyTokenLocalSwitch', // CSS classes for styling
                            rows: [
                                { view: 'label', label: _('Token Local') }, // Label for the form
                                {
                                    id: 'StateContingencyTokenLocalSwith', // Unique identifier for the switch
                                    view: 'switch', // Switch view for local token state
                                    labelWidth: 55, // Width of the label next to the switch
                                    onLabel: _('Activo'), // Label for the 'on' state
                                    offLabel: _('Inactivo'), // Label for the 'off' state
                                    click: () => { // Click event handler for the switch
                                        if ($$('StateContingencyTokenLocalSwith').getValue() == 1) { // Checking if switch is on
                                            webix
                                                .ajax() // Initiating an AJAX request
                                                .headers({
                                                    'Content-type': 'application/json', // Setting content type for the request
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'Client/UpdateUserSecurity', // API endpoint for updating user security
                                                    '{"Action":"ContingencyTokenLocal","Id":' +
                                                    cur_user +
                                                    ',"IsActivate":"A"}', // Request payload
                                                    {
                                                        error: function(text, data, XmlHttpRequest) { // Error callback
                                                            webix.message({
                                                                title: _('¡Error!'), // Error message title
                                                                type: 'alert-error', // Type of alert
                                                                text: _('Ocurrio un error.'), // Error message text
                                                            });
                                                        },
                                                        success: function(text, data, XmlHttpRequest) { // Success callback
                                                            webix.message(_('Cambios Realizados')); // Success message
                                                            $$('StateContingencyTokenLocalSwith').setValue(1); // Setting switch value
                                                        },
                                                    },
                                                );
                                        } else {
                                            webix
                                                .ajax() // Initiating an AJAX request
                                                .headers({
                                                    'Content-type': 'application/json', // Setting content type for the request
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'Client/UpdateUserSecurity', // API endpoint for updating user security
                                                    '{"Action":"ContingencyTokenLocal","Id":' +
                                                    cur_user +
                                                    ',"IsActivate":"I"}', // Request payload
                                                    {
                                                        error: function(text, data, XmlHttpRequest) { // Error callback
                                                            webix.message({
                                                                title: _('¡Error!'), // Error message title
                                                                type: 'alert-error', // Type of alert
                                                                text: _('Ocurrio un error.'), // Error message text
                                                            });
                                                        },
                                                        success: function(text, data, XmlHttpRequest) { // Success callback
                                                            webix.message(_('Cambios Realizados')); // Success message
                                                            $$('StateContingencyTokenLocalSwith').setValue(0); // Setting switch value
                                                        },
                                                    },
                                                );
                                        }
                                    },
                                },
                            ],
                        },
                        { id: 'grav2', gravity: 1 }, // Gravity for layout adjustment
                    ],
                },
            ],
        };

        // Define the upper_section object with properties for height, CSS class, and layout rows
        const upper_section = {
            // Set height based on the document's body width
            height: document.body.offsetWidth < 500 ? 1550 : 0,
            // CSS class for styling
            css: 'secutity',
            // Define rows containing columns
            rows: [
                {
                    // Margin for the row
                    margin: 10,
                    // Columns within the row, with 'left' presumably defined elsewhere
                    cols: [left],
                },
            ],
        };

        // Return an object representing a form view
        return {
            // Type of view
            view: 'form',
            // Unique identifier for the form
            id: 'myForm',
            // Rows to be included in the form, including upper_section
            rows: [upper_section],
            // Validation rules for form fields
            rules: {
                // Rule to ensure the 'fname' field is not empty
                fname: webix.rules.isNotEmpty,
            },
        }; // Placeholder for the configuration content
    }

    /**
     * Initializes the view and its components.
     * @param {Object} grid - The grid component to be initialized.
     */
    init(grid) {
        // Retrieve the current user parameter from the URL or context
        const cur_user = this.getParam('user', true);

        // Add CSS styles for background colors
        webix.html.addStyle(
            '.bkgRed{ background:rgba(255, 0, 0, 0.5803921568627451) !important; }', // Style for red background
        );
        webix.html.addStyle(
            '.bkgGreen{ background:rgba(3, 199, 3, 0.35) !important; }', // Style for green background
        );

        // Perform an AJAX GET request to fetch client data by user ID
        webix.ajax().get(
            devConfig.geturlApi() + 'Client/GetClientSpById', // API endpoint
            'id=' + cur_user, // Query parameter with current user ID
            {
                // Error callback function
                error: function(text, data, XmlHttpRequest) {
                    webix.message({
                        title: _('¡Error!'), // Error message title
                        type: 'alert-error', // Message type
                        text: _('Ocurrio un error.'), // Error message text
                    });
                },
                // Success callback function
                success: function(text, data, XmlHttpRequest) {
                    text = JSON.parse(text); // Parse the JSON response

                    // Set the IP value in the UI component
                    $$('IP').setValue(text[0].IP);

                    // Set the state of various switches based on the response
                    if (text[0].IsActivate == 'A') {
                        $$('StateSwith').setValue(1); // Active state
                    } else {
                        $$('StateSwith').setValue(0); // Inactive state
                    }
                    if (text[0].IsActivateContingency == 'A') {
                        $$('StateContingencySwith').setValue(1); // Active contingency state
                    } else {
                        $$('StateContingencySwith').setValue(0); // Inactive contingency state
                    }
                    if (text[0].IsActivateContingencyDeportivas == 'A') {
                        $$('StateContingencyDeportivasSwith').setValue(1); // Active sports contingency state
                    } else {
                        $$('StateContingencyDeportivasSwith').setValue(0); // Inactive sports contingency state
                    }
                    if (text[0].IsActivateContingencyCasino == 'A') {
                        $$('StateContingencyCasinoSwith').setValue(1); // Active casino contingency state
                    } else {
                        $$('StateContingencyCasinoSwith').setValue(0); // Inactive casino contingency state
                    }
                    if (text[0].IsActivateContingencyCasinoVivo == 'A') {
                        $$('StateContingencyCasinoVivoSwith').setValue(1); // Active live casino contingency state
                    } else {
                        $$('StateContingencyCasinoVivoSwith').setValue(0); // Inactive live casino contingency state
                    }
                    if (text[0].IsActivateContingencyVirtuales == 'A') {
                        $$('StateContingencyVirtualesSwith').setValue(1); // Active virtual contingency state
                    } else {
                        $$('StateContingencyVirtualesSwith').setValue(0); // Inactive virtual contingency state
                    }
                    if (text[0].IsActivateContingencyPoker == 'A') {
                        $$('StateContingencyPokerSwith').setValue(1); // Active poker contingency state
                    } else {
                        $$('StateContingencyPokerSwith').setValue(0); // Inactive poker contingency state
                    }
                    if (text[0].IsRestrictionIP == 'A') {
                        $$('StateContingencyRestriccionIPSwith').setValue(1); // Active IP restriction state
                    } else {
                        $$('StateContingencyRestriccionIPSwith').setValue(0); // Inactive IP restriction state
                    }
                    if (text[0].IsTokenGoogle == 'A') {
                        $$('StateContingencyTokenGoogleSwith').setValue(1); // Active Google token state
                    } else {
                        $$('StateContingencyTokenGoogleSwith').setValue(0); // Inactive Google token state
                    }
                    if (text[0].IsTokenLocal == 'A') {
                        $$('StateContingencyTokenLocalSwith').setValue(1); // Active local token state
                    } else {
                        $$('StateContingencyTokenLocalSwith').setValue(0); // Inactive local token state
                    }
                    console.log(text); // Log the response for debugging
                },
            },
        ); // Placeholder for the initialization content
    }
}

// FILE DOCUMENTED
